export default __webpack_public_path__ + "static/media/download_csv.fc3dbb45.svg";